import { FC, useMemo } from 'react';
import { Location, Navigate, useLocation } from 'react-router-dom';

import { isDefined } from '@hsp/utilities';

import { paths } from 'constants/paths';
import { IRedirectToLoginProps } from 'types/components/redirect/login';
import { buildUrl } from 'utilities/strings';

const RedirectToLogin: FC<IRedirectToLoginProps> = ({ from }) => {
  const location = useLocation();
  const url = useMemo(() => buildUrl('Root.children.Login'), []);
  let state: Record<string, Location> | undefined = {};

  state.from = isDefined(from) ? from : location;

  if (state.from.pathname.includes(paths.Root.children.Logout)) {
    state = undefined;
  }

  return (
    <Navigate
      replace
      state={state}
      to={url}
    />
  );
};

export default RedirectToLogin;
